
import { AccessCodes } from "./types";

export const useFeatureVisibility = (
  authorizedFeatures: string[],
  accessCodes: AccessCodes,
  visibleMenuItems: string[]
) => {
  const isFeatureDisabled = (feature?: string) => {
    if (!feature) return false;
    if (feature === "dashboard") return false;
    
    return !authorizedFeatures.includes(feature);
  };

  const shouldShowEyeIcon = (feature?: string) => {
    if (!feature) return false;
    if (["dashboard", "poultry", "stock", "history", "suppliers"].includes(feature)) return false;
    
    return ["staff", "budget", "settings"].includes(feature);
  };

  const isFeatureVisible = (feature?: string) => {
    if (!feature) return true;
    if (feature === "dashboard") return true;
    
    return visibleMenuItems.includes(feature);
  };

  return {
    isFeatureDisabled,
    shouldShowEyeIcon,
    isFeatureVisible,
  };
};
